import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { SignUpFormTyping } from "./TabsController";
import { TabProperties } from "../types";
import BaseInput from "@reusables/BaseInput";
import BaseInputsGrid from "@reusables/BaseInputsGrid";
import BasePhoneInput from "@reusables/BasePhoneInput";
import BaseButton from "@reusables/BaseButton";
import { useTranslation } from "react-i18next";
import BasePasswordInputWrapper from "@/components/reusables/passwords/BasePasswordRulesWrapper";

export default function YourProfileTab({onNext}: TabProperties) {
    const {t} = useTranslation("", {keyPrefix: "signupPage.yourProfile"});

    const {control, setValue, trigger} = useFormContext<SignUpFormTyping>();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const isProfileValid = await trigger('your_profile');

        if (isProfileValid) {
            onNext(e);
        }
    };

    return (
        <>
            <div className="flex flex-col my-16 space-y-8">
                <div className="text-2xl font-semibold text-center text-accent">{t("heading")}</div>
                <div className="text-xl font-thin text-center text-secondary-gray">{t("subheading")}</div>
            </div>
            <form className="space-y-[40px]" onSubmit={handleSubmit}>
                <BaseInputsGrid cols={{xs: 1, sm: 2}} gap={{x: 32, y: 24}}>
                    <Controller
                        control={control}
                        name="your_profile.first_name"
                        render={({field, fieldState}) => (
                            <BaseInput
                                {...field}
                                error={fieldState.error}
                                label={t("fields.firstName")}
                                onChange={(e) => {
                                    field.onChange(e);
                                    if (fieldState.error) {
                                        trigger('your_profile.first_name');
                                    }
                                }}
                            />
                        )}
                    />
                    <Controller
                        control={control}
                        name="your_profile.last_name"
                        render={({field, fieldState}) => (
                            <BaseInput
                                {...field}
                                error={fieldState.error}
                                label={t("fields.lastName")}
                                onChange={(e) => {
                                    field.onChange(e);
                                    if (fieldState.error) {
                                        trigger('your_profile.last_name');
                                    }
                                }}
                            />
                        )}
                    />

                    <Controller
                        control={control}
                        name="your_profile.email"
                        render={({field, fieldState}) => (
                            <BaseInput
                                {...field}
                                error={fieldState.error}
                                label={t("fields.email")}
                                onChange={(e) => {
                                    field.onChange(e);
                                    if(fieldState.error) {
                                        trigger('your_profile.email');
                                    }
                                }}
                            />
                        )}
                    />

                    <Controller
                        control={control}
                        name="your_profile.phone.number"
                        render={({field, fieldState}) => (
                            <BasePhoneInput
                                {...field}
                                {...fieldState}
                                label={t("fields.phone")}
                                variant={"custom"}
                                onChange={(e) => {
                                    field.onChange(e);
                                    if (fieldState.error) {
                                        trigger('your_profile.phone.number');
                                    }
                                }}
                                onValueChange={(value, country) => {
                                    setValue("your_profile.phone.code", country.countryCode);
                                }}
                            />
                        )}
                    />

                    <Controller
                        control={control}
                        name="your_profile.password"
                        render={({ field, fieldState }) => (
                            <BasePasswordInputWrapper value={field.value}>
                                <BaseInput
                                    {...field}
                                    error={fieldState.error}
                                    label={t("fields.password")}
                                    type="password"
                                    onChange={(e) => {
                                        field.onChange(e);
                                        if (fieldState.error) {
                                            trigger('your_profile.password');
                                        }
                                    }}
                                    hideErrors
                                />
                            </BasePasswordInputWrapper>
                        )}
                    />

                    <Controller
                        control={control}
                        name="your_profile.confirm_password"
                        render={({field, fieldState}) => (
                            <BaseInput
                                {...field}
                                error={fieldState.error}
                                label={t("fields.confirmPassword")}
                                type="password"
                                onChange={(e) => {
                                    field.onChange(e);
                                    if (fieldState.error) {
                                        trigger('your_profile.confirm_password');
                                    }
                                }}
                            />
                        )}
                    />
                </BaseInputsGrid>

                <div className="flex justify-center">
                    <BaseButton
                        text={t("button")}
                        size="md"
                        style={{backgroundImage: 'linear-gradient(90.89deg, #2B2A35 0.67%, #6959FC 99.24%) 1'}}
                    />
                </div>
            </form>
        </>
    )
}